// Single source of truth for all countries, currencies, and flags.
// Used by: CurrencyContext, CountrySelector, ProductCard, Home, ProductDetail, AdminDashboard, FeaturedShops

// ISO 3166 country code → currency code (ISO 4217)
export const COUNTRY_CURRENCY = {
  AF:'AFN',AL:'ALL',DZ:'DZD',AD:'EUR',AO:'AOA',AG:'XCD',AR:'ARS',AM:'AMD',
  AU:'AUD',AT:'EUR',AZ:'AZN',BS:'BSD',BH:'BHD',BD:'BDT',BB:'BBD',BY:'BYN',
  BE:'EUR',BZ:'BZD',BJ:'XOF',BT:'BTN',BO:'BOB',BA:'BAM',BW:'BWP',BR:'BRL',
  BN:'BND',BG:'BGN',BF:'XOF',BI:'BIF',KH:'KHR',CM:'XAF',CA:'CAD',CF:'XAF',
  TD:'XAF',CL:'CLP',CN:'CNY',CO:'COP',KM:'KMF',CG:'XAF',CR:'CRC',HR:'EUR',
  CU:'CUP',CY:'EUR',CZ:'CZK',DK:'DKK',DJ:'DJF',DO:'DOP',EC:'USD',EG:'EGP',
  SV:'USD',GQ:'XAF',ER:'ERN',EE:'EUR',SZ:'SZL',ET:'ETB',FJ:'FJD',FI:'EUR',
  FR:'EUR',GA:'XAF',GM:'GMD',GE:'GEL',DE:'EUR',GH:'GHS',GR:'EUR',GT:'GTQ',
  GN:'GNF',GY:'GYD',HT:'HTG',HN:'HNL',HU:'HUF',IS:'ISK',IN:'INR',ID:'IDR',
  IR:'IRR',IQ:'IQD',IE:'EUR',IL:'ILS',IT:'EUR',JM:'JMD',JP:'JPY',JO:'JOD',
  KZ:'KZT',KE:'KES',KW:'KWD',KG:'KGS',LA:'LAK',LV:'EUR',LB:'LBP',LS:'LSL',
  LR:'LRD',LY:'LYD',LI:'CHF',LT:'EUR',LU:'EUR',MG:'MGA',MW:'MWK',MY:'MYR',
  MV:'MVR',ML:'XOF',MT:'EUR',MR:'MRU',MU:'MUR',MX:'MXN',MD:'MDL',MC:'EUR',
  MN:'MNT',ME:'EUR',MA:'MAD',MZ:'MZN',MM:'MMK',NA:'NAD',NP:'NPR',NL:'EUR',
  NZ:'NZD',NI:'NIO',NE:'XOF',NG:'NGN',MK:'MKD',NO:'NOK',OM:'OMR',PK:'PKR',
  PA:'PAB',PG:'PGK',PY:'PYG',PE:'PEN',PH:'PHP',PL:'PLN',PT:'EUR',QA:'QAR',
  RO:'RON',RU:'RUB',RW:'RWF',SA:'SAR',SN:'XOF',RS:'RSD',SL:'SLE',SG:'SGD',
  SK:'EUR',SI:'EUR',SO:'SOS',ZA:'ZAR',KR:'KRW',SS:'SSP',ES:'EUR',LK:'LKR',
  SD:'SDG',SR:'SRD',SE:'SEK',CH:'CHF',SY:'SYP',TW:'TWD',TJ:'TJS',TZ:'TZS',
  TH:'THB',TG:'XOF',TT:'TTD',TN:'TND',TR:'TRY',TM:'TMT',UG:'UGX',UA:'UAH',
  AE:'AED',GB:'GBP',US:'USD',UY:'UYU',UZ:'UZS',VE:'VES',VN:'VND',YE:'YER',
  ZM:'ZMW',ZW:'ZWL',
};

// Full country list: name + ISO code
export const COUNTRIES = [
  {name:"Afghanistan",code:"AF"},{name:"Albania",code:"AL"},{name:"Algeria",code:"DZ"},
  {name:"Andorra",code:"AD"},{name:"Angola",code:"AO"},{name:"Antigua and Barbuda",code:"AG"},
  {name:"Argentina",code:"AR"},{name:"Armenia",code:"AM"},{name:"Australia",code:"AU"},
  {name:"Austria",code:"AT"},{name:"Azerbaijan",code:"AZ"},{name:"Bahamas",code:"BS"},
  {name:"Bahrain",code:"BH"},{name:"Bangladesh",code:"BD"},{name:"Barbados",code:"BB"},
  {name:"Belarus",code:"BY"},{name:"Belgium",code:"BE"},{name:"Belize",code:"BZ"},
  {name:"Benin",code:"BJ"},{name:"Bhutan",code:"BT"},{name:"Bolivia",code:"BO"},
  {name:"Bosnia and Herzegovina",code:"BA"},{name:"Botswana",code:"BW"},{name:"Brazil",code:"BR"},
  {name:"Brunei",code:"BN"},{name:"Bulgaria",code:"BG"},{name:"Burkina Faso",code:"BF"},
  {name:"Burundi",code:"BI"},{name:"Cambodia",code:"KH"},{name:"Cameroon",code:"CM"},
  {name:"Canada",code:"CA"},{name:"Central African Republic",code:"CF"},{name:"Chad",code:"TD"},
  {name:"Chile",code:"CL"},{name:"China",code:"CN"},{name:"Colombia",code:"CO"},
  {name:"Comoros",code:"KM"},{name:"Congo",code:"CG"},{name:"Costa Rica",code:"CR"},
  {name:"Croatia",code:"HR"},{name:"Cuba",code:"CU"},{name:"Cyprus",code:"CY"},
  {name:"Czech Republic",code:"CZ"},{name:"Denmark",code:"DK"},{name:"Djibouti",code:"DJ"},
  {name:"Dominican Republic",code:"DO"},{name:"Ecuador",code:"EC"},{name:"Egypt",code:"EG"},
  {name:"El Salvador",code:"SV"},{name:"Equatorial Guinea",code:"GQ"},{name:"Eritrea",code:"ER"},
  {name:"Estonia",code:"EE"},{name:"Eswatini",code:"SZ"},{name:"Ethiopia",code:"ET"},
  {name:"Fiji",code:"FJ"},{name:"Finland",code:"FI"},{name:"France",code:"FR"},
  {name:"Gabon",code:"GA"},{name:"Gambia",code:"GM"},{name:"Georgia",code:"GE"},
  {name:"Germany",code:"DE"},{name:"Ghana",code:"GH"},{name:"Greece",code:"GR"},
  {name:"Guatemala",code:"GT"},{name:"Guinea",code:"GN"},{name:"Guyana",code:"GY"},
  {name:"Haiti",code:"HT"},{name:"Honduras",code:"HN"},{name:"Hungary",code:"HU"},
  {name:"Iceland",code:"IS"},{name:"India",code:"IN"},{name:"Indonesia",code:"ID"},
  {name:"Iran",code:"IR"},{name:"Iraq",code:"IQ"},{name:"Ireland",code:"IE"},
  {name:"Israel",code:"IL"},{name:"Italy",code:"IT"},{name:"Jamaica",code:"JM"},
  {name:"Japan",code:"JP"},{name:"Jordan",code:"JO"},{name:"Kazakhstan",code:"KZ"},
  {name:"Kenya",code:"KE"},{name:"Kuwait",code:"KW"},{name:"Kyrgyzstan",code:"KG"},
  {name:"Laos",code:"LA"},{name:"Latvia",code:"LV"},{name:"Lebanon",code:"LB"},
  {name:"Lesotho",code:"LS"},{name:"Liberia",code:"LR"},{name:"Libya",code:"LY"},
  {name:"Liechtenstein",code:"LI"},{name:"Lithuania",code:"LT"},{name:"Luxembourg",code:"LU"},
  {name:"Madagascar",code:"MG"},{name:"Malawi",code:"MW"},{name:"Malaysia",code:"MY"},
  {name:"Maldives",code:"MV"},{name:"Mali",code:"ML"},{name:"Malta",code:"MT"},
  {name:"Mauritania",code:"MR"},{name:"Mauritius",code:"MU"},{name:"Mexico",code:"MX"},
  {name:"Moldova",code:"MD"},{name:"Monaco",code:"MC"},{name:"Mongolia",code:"MN"},
  {name:"Montenegro",code:"ME"},{name:"Morocco",code:"MA"},{name:"Mozambique",code:"MZ"},
  {name:"Myanmar",code:"MM"},{name:"Namibia",code:"NA"},{name:"Nepal",code:"NP"},
  {name:"Netherlands",code:"NL"},{name:"New Zealand",code:"NZ"},{name:"Nicaragua",code:"NI"},
  {name:"Niger",code:"NE"},{name:"Nigeria",code:"NG"},{name:"North Macedonia",code:"MK"},
  {name:"Norway",code:"NO"},{name:"Oman",code:"OM"},{name:"Pakistan",code:"PK"},
  {name:"Panama",code:"PA"},{name:"Papua New Guinea",code:"PG"},{name:"Paraguay",code:"PY"},
  {name:"Peru",code:"PE"},{name:"Philippines",code:"PH"},{name:"Poland",code:"PL"},
  {name:"Portugal",code:"PT"},{name:"Qatar",code:"QA"},{name:"Romania",code:"RO"},
  {name:"Russia",code:"RU"},{name:"Rwanda",code:"RW"},{name:"Saudi Arabia",code:"SA"},
  {name:"Senegal",code:"SN"},{name:"Serbia",code:"RS"},{name:"Sierra Leone",code:"SL"},
  {name:"Singapore",code:"SG"},{name:"Slovakia",code:"SK"},{name:"Slovenia",code:"SI"},
  {name:"Somalia",code:"SO"},{name:"South Africa",code:"ZA"},{name:"South Korea",code:"KR"},
  {name:"South Sudan",code:"SS"},{name:"Spain",code:"ES"},{name:"Sri Lanka",code:"LK"},
  {name:"Sudan",code:"SD"},{name:"Suriname",code:"SR"},{name:"Sweden",code:"SE"},
  {name:"Switzerland",code:"CH"},{name:"Syria",code:"SY"},{name:"Taiwan",code:"TW"},
  {name:"Tajikistan",code:"TJ"},{name:"Tanzania",code:"TZ"},{name:"Thailand",code:"TH"},
  {name:"Togo",code:"TG"},{name:"Trinidad and Tobago",code:"TT"},{name:"Tunisia",code:"TN"},
  {name:"Turkey",code:"TR"},{name:"Turkmenistan",code:"TM"},{name:"Uganda",code:"UG"},
  {name:"Ukraine",code:"UA"},{name:"United Arab Emirates",code:"AE"},
  {name:"United Kingdom",code:"GB"},{name:"United States",code:"US"},
  {name:"Uruguay",code:"UY"},{name:"Uzbekistan",code:"UZ"},{name:"Venezuela",code:"VE"},
  {name:"Vietnam",code:"VN"},{name:"Yemen",code:"YE"},{name:"Zambia",code:"ZM"},
  {name:"Zimbabwe",code:"ZW"},
];

// Code → Name lookup
export const CODE_TO_NAME = Object.fromEntries(COUNTRIES.map(c => [c.code, c.name]));

// Name → Code lookup
export const NAME_TO_CODE = Object.fromEntries(COUNTRIES.map(c => [c.name, c.code]));

// Generate flag emoji from 2-letter ISO code using regional indicator symbols
export function countryFlag(codeOrName) {
  const code = codeOrName?.length === 2
    ? codeOrName.toUpperCase()
    : NAME_TO_CODE[codeOrName];
  if (!code || code.length !== 2) return '';
  return String.fromCodePoint(...[...code].map(c => 0x1F1E6 + c.charCodeAt(0) - 65));
}

// Get currency for a country code, fallback to USD
export function currencyForCountry(code) {
  return COUNTRY_CURRENCY[code] || 'USD';
}

// Full list for selectors: { code, name, currency, flag }
export const ALL_COUNTRIES = COUNTRIES.map(c => ({
  code: c.code,
  name: c.name,
  currency: COUNTRY_CURRENCY[c.code] || 'USD',
  flag: countryFlag(c.code),
}));

console.log(`[CountryData] ${ALL_COUNTRIES.length} countries loaded`);
